import {
  GET_ALL_PRODUCT_CATEGORIES_REQUEST,
  GET_ALL_PRODUCT_CATEGORIES_SUCCESS,
  GET_ALL_PRODUCT_CATEGORIES_FAIL,
  GET_PRODUCT_CATEGORY_REQUEST,
  GET_PRODUCT_CATEGORY_SUCCESS,
  GET_PRODUCT_CATEGORY_FAIL,
  CREATE_PRODUCT_CATEGORY_REQUEST,
  CREATE_PRODUCT_CATEGORY_SUCCESS,
  CREATE_PRODUCT_CATEGORY_FAIL,
  UPDATE_PRODUCT_CATEGORY_REQUEST,
  UPDATE_PRODUCT_CATEGORY_SUCCESS,
  UPDATE_PRODUCT_CATEGORY_FAIL,
  DELETE_PRODUCT_CATEGORY_REQUEST,
  DELETE_PRODUCT_CATEGORY_SUCCESS,
  DELETE_PRODUCT_CATEGORY_FAIL,
  TOGGLE_PRODUCT_CATEGORY_STATUS_REQUEST,
  TOGGLE_PRODUCT_CATEGORY_STATUS_SUCCESS,
  TOGGLE_PRODUCT_CATEGORY_STATUS_FAIL,
  GET_CATEGORY_PRODUCTS_REQUEST,
  GET_CATEGORY_PRODUCTS_SUCCESS,
  GET_CATEGORY_PRODUCTS_FAIL,
  RESET_PRODUCT_CATEGORY_STATE
} from "./actionTypes"

const INIT_STATE = {
  categories: [],
  category: null,
  categoryProducts: [],
  loading: false,
  error: null,
  createLoading: false,
  createError: null,
  updateLoading: false,
  updateError: null,
  deleteLoading: false,
  deleteError: null,
  toggleLoading: false,
  toggleError: null
}

const ProductCategoriesReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    // Get all product categories
    case GET_ALL_PRODUCT_CATEGORIES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      }

    case GET_ALL_PRODUCT_CATEGORIES_SUCCESS:
      return {
        ...state,
        loading: false,
        categories: action.payload,
        error: null
      }

    case GET_ALL_PRODUCT_CATEGORIES_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      }

    // Get single product category
    case GET_PRODUCT_CATEGORY_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        category: null
      }

    case GET_PRODUCT_CATEGORY_SUCCESS:
      return {
        ...state,
        loading: false,
        category: action.payload,
        error: null
      }

    case GET_PRODUCT_CATEGORY_FAIL:
      return {
        ...state,
        loading: false,
        category: null,
        error: action.payload
      }

    // Create product category
    case CREATE_PRODUCT_CATEGORY_REQUEST:
      return {
        ...state,
        createLoading: true,
        createError: null
      }

    case CREATE_PRODUCT_CATEGORY_SUCCESS:
      return {
        ...state,
        createLoading: false,
        categories: [...state.categories, action.payload],
        createError: null
      }

    case CREATE_PRODUCT_CATEGORY_FAIL:
      return {
        ...state,
        createLoading: false,
        createError: action.payload
      }

    // Update product category
    case UPDATE_PRODUCT_CATEGORY_REQUEST:
      return {
        ...state,
        updateLoading: true,
        updateError: null
      }

    case UPDATE_PRODUCT_CATEGORY_SUCCESS:
      return {
        ...state,
        updateLoading: false,
        categories: state.categories.map(cat =>
          cat.id === action.payload.id ? action.payload : cat
        ),
        category: state.category?.id === action.payload.id ? action.payload : state.category,
        updateError: null
      }

    case UPDATE_PRODUCT_CATEGORY_FAIL:
      return {
        ...state,
        updateLoading: false,
        updateError: action.payload
      }

    // Delete product category
    case DELETE_PRODUCT_CATEGORY_REQUEST:
      return {
        ...state,
        deleteLoading: true,
        deleteError: null
      }

    case DELETE_PRODUCT_CATEGORY_SUCCESS:
      return {
        ...state,
        deleteLoading: false,
        categories: state.categories.filter(cat => cat.id !== action.payload),
        deleteError: null
      }

    case DELETE_PRODUCT_CATEGORY_FAIL:
      return {
        ...state,
        deleteLoading: false,
        deleteError: action.payload
      }

    // Toggle product category status
    case TOGGLE_PRODUCT_CATEGORY_STATUS_REQUEST:
      return {
        ...state,
        toggleLoading: true,
        toggleError: null
      }

    case TOGGLE_PRODUCT_CATEGORY_STATUS_SUCCESS:
      return {
        ...state,
        toggleLoading: false,
        categories: state.categories.map(cat =>
          cat.id === action.payload.categoryId
            ? { ...cat, iS_ACTIVE: action.payload.isActive }
            : cat
        ),
        category: state.category?.id === action.payload.categoryId
          ? { ...state.category, iS_ACTIVE: action.payload.isActive }
          : state.category,
        toggleError: null
      }

    case TOGGLE_PRODUCT_CATEGORY_STATUS_FAIL:
      return {
        ...state,
        toggleLoading: false,
        toggleError: action.payload
      }

    // Get products from category
    case GET_CATEGORY_PRODUCTS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        categoryProducts: []
      }

    case GET_CATEGORY_PRODUCTS_SUCCESS:
      return {
        ...state,
        loading: false,
        categoryProducts: action.payload,
        error: null
      }

    case GET_CATEGORY_PRODUCTS_FAIL:
      return {
        ...state,
        loading: false,
        categoryProducts: [],
        error: action.payload
      }

    // Reset state
    case RESET_PRODUCT_CATEGORY_STATE:
      return {
        ...INIT_STATE
      }

    default:
      return state
  }
}

export default ProductCategoriesReducer